import React from 'react';

interface SunIconProps {
  size?: number;
  strokeWidth?: number;
  color?: string;
  className?: string;
}

/**
 * SunIcon - SuperKonnected "like" icon
 * - 24x24 grid
 * - strokeWidth: 1.5
 * - Rounded linecaps
 * - No fills
 */
export const SunIcon: React.FC<SunIconProps> = ({
  size = 24,
  strokeWidth = 1.5,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2" />
      <path d="M12 20v2" />
      <path d="M4.93 4.93l1.41 1.41" />
      <path d="M17.66 17.66l1.41 1.41" />
      <path d="M2 12h2" />
      <path d="M20 12h2" />
      <path d="M6.34 17.66l-1.41 1.41" />
      <path d="M19.07 4.93l-1.41 1.41" />
    </svg>
  );
};





























